enum RegistrationTypeEnum {
  None,
  Upload,
  Manual,
  CopyPaste,
  Migration,
}

export default RegistrationTypeEnum
